"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/scp-heal-logo-text.svg.js",
    _path,
    _path2,
    _g,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 150,
    height: 60,
    viewBox: "0 0 150 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M76 22.352v-9.48h2.208v1.355c.392-.922 1.337-1.543 2.525-1.543 1.28 0 2.153.545 2.617 1.655.538-1.11 1.558-1.655 3.062-1.655 2.06 0 3.248 1.449 3.248 3.8v5.867h-2.23v-5.547c0-1.297-.612-2.107-1.67-2.107-1.095 0-1.856.903-1.856 2.2v5.455h-2.206v-5.548c0-1.297-.612-2.107-1.67-2.107-1.04 0-1.82.922-1.82 2.2v5.455H76zm18.077.13l-3.84-9.611h2.281l2.728 6.92 2.803-6.918h2.283L94.838 26h-2.264l1.503-3.518zm38.42-12.012c-.975-.904-2.36-1.382-4.009-1.382h-3.126v13.335h2.212v-3.066h.914c1.649 0 3.034-.475 4.008-1.372.984-.908 1.504-2.205 1.504-3.745 0-1.553-.52-2.857-1.503-3.77zm-4.923.733h.843c2.213 0 3.336 1.022 3.336 3.037 0 1.991-1.123 3-3.336 3h-.843v-6.037zm-21.02 3.496l-.977-.469c-1.461-.695-1.828-.982-1.828-1.818 0-.789.587-1.319 1.462-1.319.904 0 1.485.325 1.946 1.094l.28.465 1.778-1.153-.273-.447C108.1 9.672 106.874 9 105.192 9c-2.105 0-3.633 1.45-3.633 3.448 0 1.95 1.182 2.903 3.089 3.81l.98.469c1.525.717 1.966 1.2 1.966 2.16 0 .983-.786 1.57-2.1 1.57-1.184 0-2.141-.584-2.693-1.64l-.247-.47-1.908 1.016.247.473c.927 1.772 2.567 2.748 4.619 2.748 1.273 0 2.346-.343 3.103-.99.776-.666 1.187-1.614 1.187-2.745 0-2.145-1.242-3.182-3.248-4.15zm15.505 3.523l-.306.416c-.881 1.19-2.153 1.819-3.678 1.819-2.575 0-4.443-1.962-4.443-4.664 0-2.66 1.872-4.663 4.351-4.663 1.45 0 2.611.558 3.453 1.663l.315.41 1.739-1.27-.328-.436c-1.228-1.632-3.012-2.494-5.158-2.494-3.781 0-6.633 2.918-6.633 6.79-.009 1.872.663 3.592 1.893 4.844 1.23 1.252 2.931 1.951 4.775 1.951 2.299 0 4.136-.894 5.46-2.658l.331-.44-1.771-1.268z",
    fill: "#878787",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  })), _path2 || (_path2 = React.createElement("path", {
    d: "M86.868 32h4.056v18.018h-4.056v-7.644h-6.812v7.644H76V32h4.056v6.89h6.812V32zM97.694 50.018V32h12.168v3.406h-8.112v3.536h7.202v3.328h-7.202v4.342h8.71v3.406H97.694zM128.125 50.018a35.15 35.15 0 00-.65-1.924l-.676-1.976h-7.02a86.422 86.422 0 01-.702 1.976c-.225.659-.433 1.3-.624 1.924h-4.212a326.943 326.943 0 011.924-5.382 235.838 235.838 0 011.768-4.654 251.29 251.29 0 011.716-4.134A99.918 99.918 0 01121.417 32h3.874c.59 1.248 1.17 2.53 1.742 3.848.572 1.3 1.144 2.678 1.716 4.134a154.43 154.43 0 011.794 4.654c.607 1.647 1.248 3.44 1.924 5.382h-4.342zm-4.862-13.936c-.086.26-.216.615-.39 1.066l-.598 1.56c-.225.59-.476 1.24-.754 1.95-.26.71-.528 1.456-.806 2.236h5.122a250.71 250.71 0 00-.806-2.236c-.26-.71-.511-1.36-.754-1.95-.225-.59-.424-1.11-.598-1.56-.173-.45-.312-.806-.416-1.066zM149.438 46.534v3.484H137.4V32h4.056v14.534h7.982z",
    fill: "#2A2A2A",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  })), _g || (_g = React.createElement("g", {
    clipPath: "url(#prefix__clip0_5535_34972)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: this
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.328 7a10.536 10.536 0 11.017 21.073A10.536 10.536 0 0130.328 7z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22
    },
    __self: this
  }), React.createElement("path", {
    d: "M1.15 22.287S-2.806 48.87 29.672 53.269c0 0-1.57-30.715-28.522-30.982z",
    fill: "#0D1F36",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28
    },
    __self: this
  }), React.createElement("path", {
    d: "M58.85 22.287S62.83 48.87 30.328 53.269c0 0 1.588-30.715 28.522-30.982z",
    fill: "#B5BD00",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32
    },
    __self: this
  }))), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37
    },
    __self: this
  }, React.createElement("clipPath", {
    id: "prefix__clip0_5535_34972",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38
    },
    __self: this
  }, React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 7)",
    d: "M0 0h58v46.269H0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;